import { useEffect } from 'react';

export default function useWidgetResize() {
  useEffect(() => {
    const allowedParentOrigins = [
      'https://toponeav.com.br',
      'https://www.toponeav.com.br',
      'http://localhost:3000',
      'http://127.0.0.1:3000',
    ];
    const getParentOrigin = () => {
      try {
        const referrerOrigin = new URL(document.referrer).origin;
        return allowedParentOrigins.includes(referrerOrigin) ? referrerOrigin : null;
      } catch {
        return null;
      }
    };

    const parentOrigin = getParentOrigin();
    const content = document.querySelector('#celeritas-content, .widget-page');
    if (!content) return undefined;

    let lastHeight = 0;
    let timeout;

    const getContentHeight = () => Math.ceil(content.getBoundingClientRect().height);

    const sendHeight = () => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        const height = getContentHeight();
        if (!parentOrigin || height <= 0 || height === lastHeight) return;

        lastHeight = height;
        console.log('[Celeritas] resize', height);
        window.parent?.postMessage(
          { type: 'celeritas-widget-resize', height },
          parentOrigin,
        );
      }, 50);
    };

    const observer = new ResizeObserver(sendHeight);
    observer.observe(content);
    window.addEventListener('load', sendHeight);
    window.addEventListener('resize', sendHeight);
    sendHeight();

    return () => {
      window.clearTimeout(timeout);
      observer.disconnect();
      window.removeEventListener('load', sendHeight);
      window.removeEventListener('resize', sendHeight);
    };
  }, []);
}
